export const translations = {
  pl: {
    nav: {
      services: "Usługi",
      about: "O nas",
      process: "Proces",
      gallery: "Realizacje",
      trust: "Zaufali nam",
      faq: "FAQ",
      contact: "Kontakt",
      cta: "Uzyskaj wycenę",
    },
    hero: {
      tag: "Lakiernia proszkowa — od 2018",
      title1: "Powierzchnie,",
      title2: "którym ufają",
      title3: "firmy.",
      lead:
        "Profesjonalne lakierowanie proszkowe oraz piaskowanie i przygotowanie powierzchni. Współpracujemy z producentami konstrukcji stalowych, warsztatami i klientami indywidualnymi. Nowy Dwór Mazowiecki.",
      ctaPrimary: "Wyceń projekt",
      ctaSecondary: "Zobacz realizacje",
      meta: {
        loc: "Długa 9, Nowy Dwór Mazowiecki",
        rating: "Google 4,8 / 32 opinie",
        furnace: "Piec lakierniczy 7,20 m",
      },
    },
    about: {
      tag: "O firmie",
      heading: "B2B w priorytecie. Detal w tym samym standardzie.",
      lead:
        "Od ponad 7 lat dostarczamy stałą jakość producentom konstrukcji stalowych, urządzeń chłodniczych i wyposażenia obiektów. Równolegle realizujemy zlecenia indywidualne — od pojedynczych detali po zabytkowe motocykle.",
      stats: [
        { value: "7+", label: "Lat doświadczenia" },
        { value: "7,20 m", label: "Długość pieca" },
        { value: "4,8★", label: "Ocena Google (32)" },
        { value: "B2B + B2C", label: "Model współpracy" },
      ],
      bullets: [
        "Transport własny — odbiór i dostawa elementów",
        "Wytrawianie, piaskowanie, śrutowanie — kompletne przygotowanie",
        "Stal, aluminium, mosiądz, cynk",
        "Stała współpraca lub zlecenia indywidualne",
      ],
    },
    services: {
      tag: "Zakres usług",
      heading: "Dwa kluczowe procesy.",
      items: [
        {
          code: "01",
          title: "Lakierowanie proszkowe",
          desc:
            "Bramy, przęsła, balustrady, konstrukcje stalowe, obudowy, ramy, reklamy zewnętrzne, elementy zawieszenia, zaciski hamulcowe. Stal czarna, nierdzewna, aluminium, mosiądz, cynk.",
          tag: "B2B / DETAL",
        },
        {
          code: "02",
          title: "Piaskowanie i śrutowanie",
          desc:
            "Usuwanie korozji, starych powłok i zanieczyszczeń. Przygotowanie powierzchni pod malowanie proszkowe i powłoki ochronne — zgodnie z wymaganiami branży przemysłowej.",
          tag: "B2B / DETAL",
        },
      ],
    },
    process: {
      tag: "Jak działamy",
      heading: "Cztery kroki. Bez niespodzianek.",
      items: [
        {
          n: "01",
          title: "Wycena",
          desc: "Przyjmujemy zapytanie, oceniamy zakres i przygotowujemy ofertę cenową w 24h roboczych.",
        },
        {
          n: "02",
          title: "Przygotowanie",
          desc: "Odbiór elementów (transport własny), piaskowanie, śrutowanie, wytrawianie i odtłuszczanie.",
        },
        {
          n: "03",
          title: "Lakierowanie",
          desc: "Aplikacja proszku w komorze i utwardzanie w piecu 7,20 m. Pełna kontrola jakości na każdym etapie.",
        },
        {
          n: "04",
          title: "Odbiór",
          desc: "Pakowanie, dostawa lub odbiór własny. Dokumentacja i krótka rozmowa po realizacji.",
        },
      ],
    },
    gallery: {
      tag: "Realizacje",
      heading: "Wybrane prace.",
      lead:
        "Bramy, przęsła, motocykle, elementy zawieszenia, reklamy zewnętrzne, konstrukcje stalowe i obudowy myjni samochodowych.",
    },
    trust: {
      tag: "Zaufali nam",
      heading: "Firmy, z którymi współpracujemy.",
      lead:
        "Stała współpraca z producentami konstrukcji stalowych i urządzeń chłodniczych. Pełne referencje na życzenie.",
      partners: [
        "Arteo Sp. z o.o. Design",
        "PPH COOL",
        "Steel Harmony",
        "NEON",
        "Bank Polski (reklama)",
        "Intermarché (myjnia)",
        "Eterna (myjnia)",
      ],
    },
    testimonials: {
      tag: "Referencje",
      heading: "Co mówią nasi partnerzy.",
      items: [
        {
          quote:
            "Firma sumiennie i terminowo wywiązuje się z powierzonych prac. Elementy zawsze lakierowane są z wysoką dbałością i starannością. Rekomendujemy jako fachowego, oddanego i poważnego partnera biznesowego.",
          author: "Arteo Sp. z o.o. Design spk",
          date: "Współpraca od 2018",
        },
        {
          quote:
            "Realizuje dla nas od ponad 2 lat usługi lakiernicze do konstrukcji wytwarzanych przez nas urządzeń chłodniczych. Jesteśmy zadowoleni z poziomu usług i polecamy jako solidnego partnera.",
          author: "PPH COOL",
          date: "Referencja 18.01.2021",
        },
        {
          quote:
            "Stały wykonawca prac polegających na piaskowaniu i lakierowaniu proszkowym wyrobów ze stali czarnej, nierdzewnej oraz aluminium. Roboty wykonywane terminowo i z najwyższą jakością.",
          author: "Steel Harmony — Paulina Tranczewska",
          date: "Współpraca od 2018",
        },
      ],
    },
    form: {
      tag: "Wycena",
      heading: "Wyślij zapytanie.",
      lead:
        "Wypełnij formularz, oddzwonimy w 24h roboczych. W zapytaniach B2B prosimy o krótki opis projektu lub załącznik wysłany na e-mail.",
      type: {
        label: "Typ zapytania",
        b2b: "Firma (B2B)",
        retail: "Klient indywidualny",
      },
      name: "Imię i nazwisko",
      company: "Firma (opcjonalnie)",
      email: "Adres e-mail",
      phone: "Telefon",
      service: "Usługa",
      services: [
        "Lakierowanie proszkowe",
        "Piaskowanie / śrutowanie",
        "Inne",
      ],
      message: "Opis zlecenia",
      placeholderMessage:
        "Liczba elementów, wymiary, materiał, kolor RAL, termin...",
      submit: "Wyślij zapytanie",
      callNow: "Zadzwoń teraz",
      sending: "Wysyłam...",
      success: "Dziękujemy — odezwiemy się w 24h roboczych.",
      error: "Wystąpił problem. Zadzwoń bezpośrednio: 513 066 040.",
      altCall: "lub zadzwoń",
    },
    faq: {
      tag: "FAQ",
      heading: "Najczęstsze pytania.",
      items: [
        {
          q: "Czy zajmiecie się pojedynczym elementem?",
          a: "Tak. Obok stałej współpracy z firmami realizujemy zlecenia indywidualne — ramy motocyklowe, elementy zawieszenia, zaciski hamulcowe, drobne detale i pojedyncze konstrukcje.",
        },
        {
          q: "Jakie materiały lakierujecie?",
          a: "Stal czarną, nierdzewną, aluminium, mosiądz i cynk. Pełen zakres przygotowania powierzchni przed lakierowaniem.",
        },
        {
          q: "Jakie są maksymalne wymiary elementów?",
          a: "Długość pieca lakierniczego to 7,20 m — obsłużymy bramy, przęsła, długie konstrukcje stalowe i ramy reklamowe.",
        },
        {
          q: "Czy zapewniacie transport?",
          a: "Tak, dysponujemy własnym transportem — odbiór i dostawa elementów w Nowym Dworze Mazowieckim i okolicach (Warszawa, Modlin).",
        },
        {
          q: "Ile trwa realizacja?",
          a: "Standardowo 3–7 dni roboczych od dostarczenia elementów. Większe zlecenia B2B planujemy indywidualnie.",
        },
        {
          q: "Czy dobierzecie kolor RAL?",
          a: "Tak. Pracujemy w pełnej palecie RAL, a także na strukturach, połyskach i kolorach metalicznych. Doradzimy w razie wątpliwości.",
        },
      ],
    },
    contact: {
      tag: "Kontakt",
      heading: "Odwiedź lakiernię.",
      address: "Długa 9, 05-100 Nowy Dwór Mazowiecki",
      phone: "+48 513 066 040",
      hours: "Pon — Pt: 06:00 – 16:00",
      hoursWeekend: "Sob — Niedz: zamknięte",
      mapTitle: "Mapa Google",
    },
    footer: {
      tagline: "Lakiernia proszkowa · Piaskowanie · Przygotowanie powierzchni",
      rights: "Wszystkie prawa zastrzeżone.",
      privacy: "Polityka prywatności",
      cookies: "Pliki cookie",
    },
  },
  en: {
    nav: {
      services: "Services",
      about: "About",
      process: "Process",
      gallery: "Projects",
      trust: "Clients",
      faq: "FAQ",
      contact: "Contact",
      cta: "Request a quote",
    },
    hero: {
      tag: "Powder coating — since 2018",
      title1: "Surfaces",
      title2: "trusted by",
      title3: "manufacturers.",
      lead:
        "Professional powder coating, sandblasting and surface preparation. We partner with steel manufacturers, workshops and retail customers. Nowy Dwór Mazowiecki, Poland.",
      ctaPrimary: "Get a quote",
      ctaSecondary: "See our work",
      meta: {
        loc: "Długa 9, Nowy Dwór Mazowiecki",
        rating: "Google 4.8 / 32 reviews",
        furnace: "7.20 m curing oven",
      },
    },
    about: {
      tag: "About",
      heading: "B2B-first. Retail held to the same standard.",
      lead:
        "For over 7 years we've delivered consistent quality to steel manufacturers, refrigeration brands and facility builders. Alongside, we handle individual jobs — from small details to vintage motorcycles.",
      stats: [
        { value: "7+", label: "Years of experience" },
        { value: "7.20 m", label: "Oven length" },
        { value: "4.8★", label: "Google rating (32)" },
        { value: "B2B + B2C", label: "Customer model" },
      ],
      bullets: [
        "In-house transport — pickup & delivery",
        "Etching, sandblasting, shot blasting — full prep",
        "Steel, aluminium, brass, zinc",
        "Recurring contracts or one-off jobs",
      ],
    },
    services: {
      tag: "Services",
      heading: "Two core processes.",
      items: [
        {
          code: "01",
          title: "Powder coating",
          desc:
            "Gates, fences, balustrades, steel structures, enclosures, frames, outdoor signage, suspension parts, brake calipers. Mild steel, stainless, aluminium, brass, zinc.",
          tag: "B2B / RETAIL",
        },
        {
          code: "02",
          title: "Sand & shot blasting",
          desc:
            "Removing corrosion, old coatings and contamination. Surface preparation for powder coating and protective layers — to industrial-grade standards.",
          tag: "B2B / RETAIL",
        },
      ],
    },
    process: {
      tag: "How we work",
      heading: "Four steps. No surprises.",
      items: [
        {
          n: "01",
          title: "Quote",
          desc:
            "We review your request, assess scope and send a quote within 24 working hours.",
        },
        {
          n: "02",
          title: "Preparation",
          desc:
            "Pickup (own transport), sandblasting, shot blasting, etching and degreasing.",
        },
        {
          n: "03",
          title: "Coating",
          desc:
            "Powder application in the cabin and curing in the 7.20 m oven. Quality control at every step.",
        },
        {
          n: "04",
          title: "Handover",
          desc:
            "Packing, delivery or pickup. Documentation and a quick post-project call.",
        },
      ],
    },
    gallery: {
      tag: "Projects",
      heading: "Selected work.",
      lead:
        "Gates, fences, motorcycles, suspension parts, outdoor signs, steel structures and car wash enclosures.",
    },
    trust: {
      tag: "Clients",
      heading: "Companies we partner with.",
      lead:
        "Long-term partnerships with steel and refrigeration manufacturers. Full references available on request.",
      partners: [
        "Arteo Sp. z o.o. Design",
        "PPH COOL",
        "Steel Harmony",
        "NEON",
        "Bank Polski (signage)",
        "Intermarché (car wash)",
        "Eterna (car wash)",
      ],
    },
    testimonials: {
      tag: "References",
      heading: "What partners say.",
      items: [
        {
          quote:
            "The company carries out commissioned work diligently and on time. Parts are always coated with high care and precision. We recommend them as a professional, dedicated and serious business partner.",
          author: "Arteo Sp. z o.o. Design spk",
          date: "Partner since 2018",
        },
        {
          quote:
            "They have been providing coating services for our refrigeration equipment for over 2 years. We are satisfied with the quality and recommend them as a reliable partner.",
          author: "PPH COOL",
          date: "Reference 18.01.2021",
        },
        {
          quote:
            "A steady contractor for our sandblasting and powder coating of mild steel, stainless and aluminium products. Always on time and at the highest quality.",
          author: "Steel Harmony — Paulina Tranczewska",
          date: "Partner since 2018",
        },
      ],
    },
    form: {
      tag: "Quote",
      heading: "Send your request.",
      lead:
        "Fill in the form and we'll get back to you within 24 working hours. For B2B inquiries please share a brief project description or attach details by email.",
      type: { label: "Inquiry type", b2b: "Company (B2B)", retail: "Individual" },
      name: "Full name",
      company: "Company (optional)",
      email: "Email",
      phone: "Phone",
      service: "Service",
      services: [
        "Powder coating",
        "Sand / shot blasting",
        "Other",
      ],
      message: "Project description",
      placeholderMessage:
        "Number of parts, dimensions, material, RAL colour, deadline...",
      submit: "Send request",
      callNow: "Call now",
      sending: "Sending...",
      success: "Thank you — we'll get back to you within 24h.",
      error: "Something went wrong. Call directly: +48 513 066 040.",
      altCall: "or call",
    },
    faq: {
      tag: "FAQ",
      heading: "Frequent questions.",
      items: [
        {
          q: "Do you handle single items?",
          a: "Yes. Alongside B2B contracts we serve individual customers — motorcycle frames, suspension parts, brake calipers, small details and one-off structures.",
        },
        {
          q: "What materials do you coat?",
          a: "Mild steel, stainless steel, aluminium, brass and zinc. Full surface preparation included.",
        },
        {
          q: "What are the maximum part dimensions?",
          a: "Our curing oven is 7.20 m long — we handle gates, fences, long steel structures and signage frames.",
        },
        {
          q: "Do you offer transport?",
          a: "Yes — in-house pickup and delivery across Nowy Dwór Mazowiecki and the wider Warsaw / Modlin area.",
        },
        {
          q: "How long does a job take?",
          a: "Typically 3–7 working days from delivery. Larger B2B jobs are planned individually.",
        },
        {
          q: "Can you match a specific RAL colour?",
          a: "Yes. Full RAL range, plus textures, gloss levels and metallics. Happy to advise.",
        },
      ],
    },
    contact: {
      tag: "Contact",
      heading: "Visit the workshop.",
      address: "Długa 9, 05-100 Nowy Dwór Mazowiecki, Poland",
      phone: "+48 513 066 040",
      hours: "Mon — Fri: 06:00 – 16:00",
      hoursWeekend: "Sat — Sun: closed",
      mapTitle: "Google Map",
    },
    footer: {
      tagline: "Powder coating · Sandblasting · Surface preparation",
      rights: "All rights reserved.",
      privacy: "Privacy policy",
      cookies: "Cookies",
    },
  },
};
